/* eslint-disable react/prop-types */
import React from 'react';
import styles from './styles.module.scss';

/**
 * Product Title
 * @param {object} props
 * @param {string} props.affiliateLink
 * @param {Function} [props.onClick]
 * @param {string} props.productId
 * @param {string} props.productName
 */
function ProductTitle({
  affiliateLink,
  onClick = () => {},
  productId,
  productName,
}) {
  if (!affiliateLink || !productId || !productName) return null;

  return (
    <h2
      className={styles['product-title']}
      data-testid="product-title"
    >
      <a
        className={styles['product-title__link']}
        data-product-id={productId}
        data-testid="product-title__link"
        href={affiliateLink}
        onClick={onClick}
        rel="sponsored noopener noreferrer"
        target="_blank"
      >
        {productName}
      </a>
    </h2>
  );
}

export {
  ProductTitle,
};
